import { isCmoeEnabled } from "../../config/cmoeFeatureFlags";
import { competitionIdForRoomCode } from "../../domain/cmoe/competition/competitionIdForRoom";
import { mapRoomToCompetitionMeta } from "../../adapters/cmoe/roomSessionAdapter";
import { firestoreCompetitionRepository } from "../../repositories/cmoe/firestoreCompetitionRepository";
import { patchMatchFields } from "../session/matchDocumentHelpers";
import * as matchRepository from "../../repositories/matchRepository";
import { logCmoeSyncError } from "./cmoeSyncLogger";

/**
 * Ensure a room_session competition exists and link on matches/{roomCode}.
 * @param {string} roomCode
 * @returns {Promise<string | null>} competitionId or null when CMOE disabled
 */
export async function ensureRoomSessionCompetition(roomCode) {
  if (!isCmoeEnabled() || !roomCode) return null;
  try {
    const competitionId =
      competitionIdForRoomCode(roomCode);
    const existing = await firestoreCompetitionRepository.getMeta(competitionId);
    if (!existing) {
      const meta = mapRoomToCompetitionMeta(roomCode, competitionId);
      await firestoreCompetitionRepository.saveMeta(meta);
    }
    const match = await matchRepository.fetchMatch(roomCode);
    if (match && match.cmoeCompetitionId !== competitionId) {
      await patchMatchFields(roomCode, { cmoeCompetitionId: competitionId });
    }
    return competitionId;
  } catch (err) {
    logCmoeSyncError("ensure_competition_failed", err, { roomCode });
    return null;
  }
}

/**
 * @param {string} roomCode
 * @param {{ cmoeCompetitionId?: string } | null} matchDoc
 */
export function resolveCompetitionIdForRoom(roomCode, matchDoc) {
  if (matchDoc?.cmoeCompetitionId) return matchDoc.cmoeCompetitionId;
  return competitionIdForRoomCode(roomCode);
}
